import React, { useState } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import { onEnterAction } from '../utils/a11y';

export interface Props {
  displayText: string;
  iconName?: IconProp;
  classes?: string;
  isOpen: boolean;
  handleClick(): void;
  handleClose(): void;
}

export const FixedToast = ({ displayText, iconName, classes, isOpen = true, handleClick, handleClose }: Props): JSX.Element => {
  const [showToast, setShowToast] = useState<boolean>(isOpen);
  const closeToast = (): void => {
    setShowToast(false);
    handleClose();
  };

  return (
    <div className={`${showToast ? 'block' : 'hidden'} flex w-64 rounded-3xl z-[100] bg-honey-400 ${classes ?? ''}`}>
      <div
        onClick={handleClick}
        onKeyDown={(e): void => onEnterAction(e, handleClick)}
        role='button'
        tabIndex={0}
        className='relative max-h-screen pl-4 pt-4 pb-4 w-56 grid grid-cols-4 overflow-auto cursor-pointer'
      >
        <span className='place-self-center'>{iconName && (<FontAwesomeIcon icon={iconName} className='h-8' />)}</span>
        <span className='text-sm ml-2 col-span-3'>
          {displayText}
          <button aria-label='Go' type='button' onClick={handleClick}>
            <FontAwesomeIcon icon={faArrowRight} className='ml-2' size='lg' />
          </button>
        </span>
      </div>
      <button
        aria-label='Close'
        type='button'
        className='relative grid top-1 right-2 h-9 w-9'
        onClick={closeToast}
        onKeyDown={(e): void => onEnterAction(e, closeToast)}
      >
        <FontAwesomeIcon icon={faXmark} className='h-6 w-6 place-self-center' />
      </button>
    </div>
);
}
